import React from "react";

function JeuxPourTous(props) {
  return (
    <div>
      <h1>Temps de jeux pour tous</h1>
      <p>
        L’objectif est de créer une atmosphère ludique afin de se donner le
        temps de jouer ensemble.{" "}
      </p>

      <p>
        Le jeu n’est pas qu’un passe temps amusant&nbsp;: c’est aussi l’occasion
        de se rencontrer, de développer ses habiletés, d’inventer, de créer, de
        rêver…
      </p>

      <p>
        2 à 3 animateurs de LudoBlue installent le cadre ludique et sont
        présents tout au long du «temps de jeux» pour accompagner les petits et
        <br /> les grands dans leurs choix de jeux, la pratique de ceux-ci et
        l’explication des règles. A ce titre, ils seront responsables du bon
        déroulement de l’activité ludique.
      </p>

     
        
    </div>
  );
}

export default JeuxPourTous;
